import React from 'react'

const OperationDetailsComponentLoadable = React.lazy(() => import('../../OperationComponent/Operation/OperationDetail/BookingDetail/index'));

export default function BookingDetailsComponent() {
	return (
		<OperationDetailsComponentLoadable />
	)
}